import { Component, h } from '@stencil/core';

@Component({
  tag: 'a1-divider',
  styleUrl: 'a1-divider.scss',
  scoped: true,
})
export class A1Divider {
  render() {
    return <hr />;
  }
}
